// Mock data for GO VIP website

export const companyInfo = {
  name: "GO VIP",
  tagline: "Transfers de Luxo e Tours Privados",
  description: "Empresa especializada em transfers de e para o Aeroporto do Porto e tours privados pelo Norte de Portugal e Espanha.",
  whatsapp: "932651940",
  whatsappLink: "https://wa.me/351932651940",
  email: "info@govipportugal.com",
  phone: "+351 932 651 940"
};

export const services = [
  {
    id: 1,
    title: "Transfers Aeroporto",
    description: "Serviço de transfer premium de e para o Aeroporto do Porto. Conforto, pontualidade e profissionalismo.",
    icon: "Plane",
    features: ["Motorista profissional", "Veículos de luxo", "Rastreamento de voo", "Wi-Fi gratuito"],
    image: "https://images.unsplash.com/photo-1530521954074-e64f6810b32d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxhaXJwb3J0JTIwdHJhbnNmZXJ8ZW58MHx8fHwxNzc1ODA1OTE1fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Tours Privados",
    description: "Explore o Norte de Portugal e Espanha com conforto e exclusividade. Tours personalizados para você e sua família.",
    icon: "Map",
    features: ["Tours personalizados", "Guia especializado", "Roteiros flexíveis", "Grupos pequenos"],
    image: "https://images.unsplash.com/photo-1616607006500-b08d26749c64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxwb3J0dWdhbCUyMHRvdXJpc218ZW58MHx8fHwxNzc1ODA1OTExfDA&ixlib=rb-4.1.0&q=85"
  }
];

export const destinations = [
  {
    id: 1,
    name: "Braga",
    description: "A cidade dos Arcebispos, repleta de história milenar e arquitetura religiosa impressionante. Visite o Santuário do Bom Jesus do Monte e o centro histórico.",
    duration: "4-6 horas",
    highlights: ["Bom Jesus do Monte", "Sé Catedral", "Centro Histórico"],
    price: "A partir de €120",
    image: "https://images.unsplash.com/photo-1630518690256-47d9a78d22c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxwb3J0dWdhbCUyMHRvdXJpc218ZW58MHx8fHwxNzc1ODA1OTExfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Guimarães",
    description: "O berço da nação portuguesa, cidade Património Mundial da UNESCO. Descubra o castelo medieval e o centro histórico perfeitamente preservado.",
    duration: "4-5 horas",
    highlights: ["Castelo de Guimarães", "Paço dos Duques", "Centro Histórico UNESCO"],
    price: "A partir de €110",
    image: "https://images.unsplash.com/photo-1625668349843-1781791b0ae1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxndWltYXJhZXMlMjBjYXN0bGUlMjBwb3J0dWdhbCUyMG1lZGlldmFsfGVufDB8fHx8MTc3NTg0Mjg2Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Santiago de Compostela",
    description: "Espanha - Destino final do Caminho de Santiago, uma das mais importantes cidades de peregrinação do mundo cristão. Explore a majestosa catedral e a cidade velha.",
    duration: "Dia completo",
    highlights: ["Catedral de Santiago", "Cidade Velha", "Plaza del Obradoiro"],
    price: "A partir de €250",
    image: "https://images.unsplash.com/photo-1638704645810-708030b50ce5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxzYW50aWFnbyUyMGNvbXBvc3RlbGElMjBjYXRoZWRyYWwlMjBzcGFpbiUyMGdhbGljaWF8ZW58MHx8fHwxNzc1ODQzMDgyfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Aveiro",
    description: "A Veneza de Portugal, famosa pelos seus canais, barcos moliceiros coloridos e arquitetura Art Nouveau. Não deixe de provar os ovos moles!",
    duration: "5-6 horas",
    highlights: ["Canais e Moliceiros", "Costa Nova", "Centro Art Nouveau"],
    price: "A partir de €140",
    image: "https://images.unsplash.com/photo-1670613710626-55b6f7a3c42a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxhdmVpcm8lMjBjYW5hbHMlMjBtb2xpY2Vpcm9zJTIwYm9hdHMlMjBwb3J0dWdhbHxlbnwwfHx8fDE3NzU4NDI4NjJ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    name: "Fátima",
    description: "Um dos mais importantes santuários marianos do mundo. Local de peregrinação e fé, onde ocorreram as aparições de Nossa Senhora em 1917.",
    duration: "4-5 horas",
    highlights: ["Santuário de Fátima", "Basílica", "Capela das Aparições"],
    price: "A partir de €150",
    image: "https://images.unsplash.com/photo-1644953443604-ecff0776fd39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxmYXRpbWElMjBzYW5jdHVhcnklMjBwb3J0dWdhbCUyMGJhc2lsaWNhfGVufDB8fHx8MTc3NTgxMTc0N3ww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    name: "Nazaré",
    description: "Vila piscatória famosa pelas ondas gigantes e pela tradição marítima. Visite o Sítio da Nazaré e desfrute de vistas espetaculares sobre o Atlântico.",
    duration: "4-5 horas",
    highlights: ["Praia da Nazaré", "Sítio da Nazaré", "Forte de São Miguel"],
    price: "A partir de €160",
    image: "https://images.unsplash.com/photo-1738316849650-fcb05a668069?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxuYXphcmUlMjBnaWFudCUyMHdhdmUlMjBwb3J0dWdhbCUyMHN1cmZpbmd8ZW58MHx8fHwxNzc1ODExNzQ3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 7,
    name: "Douro Vinhateiro",
    description: "Vale do Douro, Património Mundial da UNESCO. Paisagens de vinhas em socalcos, quintas centenárias e o melhor vinho do Porto. Inclui prova de vinhos.",
    duration: "Dia completo",
    highlights: ["Quintas Vinícolas", "Cruzeiro no Douro", "Prova de Vinhos", "Miradouros"],
    price: "A partir de €280",
    image: "https://images.unsplash.com/photo-1638664370752-8188076afbab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxkb3VybyUyMHZhbGxleSUyMHZpbmV5YXJkcyUyMHJpdmVyJTIwcG9ydHVnYWx8ZW58MHx8fHwxNzc1ODQyODYyfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 8,
    name: "Passadiços do Paiva",
    description: "Uma experiência única na natureza! Os Passadiços do Paiva oferecem 8km de percurso ao longo do Rio Paiva, com a impressionante Ponte Suspensa 516 Arouca - a maior ponte pedonal suspensa do mundo. Paisagens deslumbrantes, quedas de água e flora única.",
    duration: "6-7 horas",
    highlights: ["Ponte Suspensa 516 Arouca", "Rio Paiva", "Passadiços em Madeira", "Garganta do Paiva"],
    price: "A partir de €180",
    image: "https://images.unsplash.com/photo-1685709637328-2043d120ef3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxwYXNzYWRpJUMzJUE3b3MlMjBkbyUyMHBhaXZhJTIwc3VzcGVuZGVkJTIwYnJpZGdlJTIwcG9ydHVnYWx8ZW58MHx8fHwxNzc2NDE4Mjk4fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria Silva",
    location: "Lisboa",
    rating: 5,
    comment: "Serviço excelente! Transfer pontual e muito confortável. O motorista foi super profissional e atencioso.",
    date: "2024-01-15"
  },
  {
    id: 2,
    name: "John Smith",
    location: "UK",
    rating: 5,
    comment: "Amazing tour to Douro Valley! Our guide was knowledgeable and the wine tasting was unforgettable. Highly recommend!",
    date: "2024-01-20"
  },
  {
    id: 3,
    name: "Carlos Mendes",
    location: "Porto",
    rating: 5,
    comment: "Fizemos o tour a Santiago de Compostela. Tudo perfeito, desde o veículo impecável até ao profissionalismo do guia. Recomendo!",
    date: "2024-02-05"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Como faço uma reserva?",
    answer: "Pode fazer a sua reserva através do calendário no nosso site, pelo WhatsApp (+351 932 651 940) ou por telefone. Confirmamos todas as reservas em 24 horas."
  },
  {
    id: 2,
    question: "Qual é a política de cancelamento?",
    answer: "Cancelamento gratuito até 24 horas antes do serviço. Para cancelamentos com menos de 24 horas, aplicamos uma taxa de 50% do valor total."
  },
  {
    id: 3,
    question: "Os tours incluem refeições?",
    answer: "Os tours de dia completo incluem pausa para almoço (não incluído no preço). Podemos recomendar restaurantes excelentes ou reservar por você."
  },
  {
    id: 4,
    question: "Quantas pessoas cabem nos veículos?",
    answer: "Temos veículos para 1-4 passageiros (sedan) e 5-8 passageiros (van). Para grupos maiores, consulte-nos."
  },
  {
    id: 5,
    question: "Os preços incluem todas as taxas?",
    answer: "Sim, os preços incluem motorista/guia, combustível, portagens e seguro. Entradas em monumentos e refeições não estão incluídas."
  }
];

// Mock function to simulate booking
export const mockBooking = (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        bookingId: `BK${Date.now()}`,
        message: "Reserva recebida com sucesso! Entraremos em contato em breve.",
        data: bookingData
      });
    }, 1000);
  });
};
